import { render } from "./MyNotificationsMenu.vue?vue&type=template&id=7e1eff1a"
import script from "./MyNotificationsMenu.vue?vue&type=script&lang=ts"
export * from "./MyNotificationsMenu.vue?vue&type=script&lang=ts"

import "./MyNotificationsMenu.vue?vue&type=style&index=0&id=7e1eff1a&lang=scss"
script.render = render

export default script